













import openApp from '@ivy/fts/openApp'
import { Component, Vue } from "vue-property-decorator"
import { isXcxWeb } from '@ivy/fts/utils'

@Component
export default class DownloadApp extends Vue {
  isXcxWeb = isXcxWeb()
  footBarShow: any = true // 浮动条是否显示
  descText: any = '下载APP，获得更多优质启蒙资源' // 下载APP，获得更多国学启蒙内容
  callLib: any = null
  callUp() {
    return openApp('readtool')
  }
  hideBar() {
    // 隐藏/关闭浮动条
    this.footBarShow = false
    this.$emit("hideFooter")
  }
}
